import dayjs, { Dayjs } from "dayjs";
import { SortType } from "../SortType";
import { FilterValue } from "../Filters/FilterValue";

export interface ProjectManagementFilters {
  page_no?: number;
  search_text?: string;
  customer_id?: FilterValue | FilterValue[];
  warehouse_id?: FilterValue | undefined;
  order_type?: string[]; // Change to string or array of strings
  order_id?: number | number[];
  start_date?: Dayjs;
  end_date?: Dayjs;
  pm_adminids?: FilterValue | FilterValue[];
  sales_adminids?: FilterValue | FilterValue[];
  min_progress_value?: number | undefined;
  max_progress_value?: number | undefined;
  archived?: boolean;
  active?: boolean;
  limit?: number;
  sort_by?: string;
  sort_type?: SortType;
  project_status?: FilterValue[];
  project_type?: FilterValue[];
  payment_status_id?: FilterValue[];
  project_category?: FilterValue[];
  dispatch_date_from?: Dayjs | null;
  dispatch_date_to?: Dayjs | null;
  created_date_from?: Dayjs | null;
  created_date_to?: Dayjs | null;
}

export const ProjectTypeFilter: FilterValue[] = [
  { id: "1", value: "Active" },
  { id: "2", value: "Archived" },
];

export const ProjectStatusFilter: FilterValue[] = [
  { id: "1", value: "All" },
  { id: "2", value: "In Progress" },
  { id: "3", value: "Archived" },
];
